import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { dashboardPlainLayoutRoute } from '../layouts/dashboard-plain-layout-route';

export const registerFormEnterpriseFormRoute = createRoute({
  getParentRoute: () => dashboardPlainLayoutRoute,
  path: '/register-form/enterprise',
  component: lazyRouteComponent(
    () => import('@/pages/register-business/register-business-enterprise-page'),
  ),
});
